/**
 * Header - Logo with lock icon for secure checkout indication
 *
 * Hidden on mobile per Figma design (mobile has lock icon in hero section instead)
 */

export function Header() {
  return (
    <header className="hidden items-center justify-between py-4 lg:flex">
      {/* Logo */}
      <img src="/images/logo-beta.svg" alt="Catch" className="h-8 w-auto" />

      {/* Secure checkout indicator */}
      <div className="flex items-center gap-1.5 text-slate-500">
        <img
          src="/images/icons/payment-page-v2/icon-ssl-lock.svg"
          alt=""
          className="h-4 w-4 opacity-60"
        />
        <span className="text-sm">Secure checkout</span>
      </div>
    </header>
  );
}

export default Header;
